import { apiGet, apiPost, apiPut, apiDelete } from "../../api/apiClient";

const BASE_PATH = "/api/admin/employees";

export const fetchEmployees = () =>
  apiGet(`${BASE_PATH}`);

export const fetchEmployeeById = (id) =>
  apiGet(`${BASE_PATH}/${id}`);

export const createEmployee = (payload) =>
  apiPost(BASE_PATH, payload);

export const updateEmployee = (id, payload) =>
  apiPut(`${BASE_PATH}/${id}`, payload);

export const deactivateEmployee = (id) =>
  apiDelete(`${BASE_PATH}/${id}`);

export const reactivateEmployee = (id) =>
  apiPost(`${BASE_PATH}/${id}/reactivate`);
